import * as ActionTypes from '../constants/actionTypes'
import { apiClient } from '../lib';

import store from '../store'

export const reset = async (params = {}) => {
  return await apiClient.organizations.availabilities.reset(params)
}



// WEBPACK FOOTER //
// ./src/actions/availabilities.js